import { Table } from '@components/Table'
import { SortingType } from '@components/Table/interface'
import { StoryTableTemplate } from '../StoryTableTemplate.tsx'
import { columns } from './components/column'
import { TopCommentSectionProps } from './interface'

export function TopCommentSection({
  data,
  handleSort,
  bookTypeChange,
  categoryChange,
  isLoading,
}: TopCommentSectionProps) {
  return (
    <StoryTableTemplate
      title='Top คอมเมนต์'
      bookTypeChange={bookTypeChange}
      categoryChange={categoryChange}
    >
      <Table
        data={data}
        columns={columns}
        fixedHeader
        onSort={handleSort}
        initialSort={{ key: 'rank', order: SortingType.ASC }}
        className='h-[355px] max-h-[355px] pr-[20px]'
        isLoading={isLoading}
      />
    </StoryTableTemplate>
  )
}
